import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

function Pnf() {

  const redirect = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      redirect('/');
    }, 2000);
  })



  return (
    <>
      <Header2 title="Page Not Found" />
      {/* Contact Start */}
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-light p-4 p-lg-5 text-center">
                <h6 className="d-inline-block text-white text-uppercase bg-primary  py-1 px-2">
                  Page Not Found
                </h6>
                <h1 className="mb-4">404</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </>
  );
}

export default Pnf;
